<template>
  <div :class="$style.root">
    <UiContainer :fluid="true">
      <span :class="[$style.header]">
        История занятий
      </span>
      <BaseTable
        :class="b()"
        :columns="columns"
        :headings="headings"
        :data="data"
        :empty-message="emptyMessage"
        :showed-line-number="true"
      >
      </BaseTable>
    </UiContainer>
  </div>
</template>

<script>
  import { getUserId } from '@/utils';
  import api from '@/api';
  import tableHelpers from '@/mixins/tableHelpers';
  import UiContainer from '@/components/UiContainer';
  import BaseTable from '@/components/BaseTable';

  const COLUMNS = [
    'date',
    'time',
    'status',
    'text',
  ];
  const HEADINGS = {
    text: 'Инструктор',
  };

  export default {
    name: 'LessonsHistory',
    components: {
      UiContainer,
      BaseTable,
    },
    mixins: [tableHelpers],
    props: {
      emptyMessage: {
        type: String,
        default: 'Ваша история занятий пуста...',
      },
    },
    data: () => ({
      studentId: getUserId(),
      columns: COLUMNS,
      data: [],
    }),
    computed: {
      headings() {
        return {
          ...HEADINGS,
          classes: this.getTableClasses(COLUMNS, 'head'),
        };
      },
    },
    created() {
      this.fetchData();
    },
    methods: {
      async fetchData() {
        const response = await api.getLessonsHistory(this.studentId);
        const data = response?.data?.map((element) => ({
          ...element,
          text: element.instructor.fullName,
          classes: this.getTableClasses(COLUMNS, 'row'),
        }));

        this.data = data || [];
      },
    },
  };
</script>

<style lang="scss" module>
  .root {
  }
  .header {
    font-weight: 500;
    @include typography(25px, 30px);
  }
</style>

<style lang="scss">

  .lessons-history {
    &__head-date,
    &__row-date {
      text-align: center;

      @include media('xs') {
        width: 85px;
        @include paddingX(15px);
      }

      @include mediaMin('sm') {
        width: 100px;
        @include paddingX(20px);
      }
    }

    &__head-time,
    &__row-time {
      text-align: center;

      @include media('xs') {
        width: 75px;
        @include paddingX(15px);
      }

      @include mediaMin('sm') {
        width: 90px;
        @include paddingX(20px);
      }
    }

    &__head-status,
    &__row-status {
      width: 150px;
      text-align: center;
    }
  }
</style>
